export const SUPPORT_LANGUAGES = [
  "Albanian",
  "Amharic",
  "Arabic",
  "Bengali",
  "Bosnian",
  "Bulgarian",
  "Burmese",
  "Catalan",
  "Chinese (Cantonese)",
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Creole",
  "Croatian",
  "Czech",
  "Danish",
  "Dutch",
  "Romanian",
  "Russian",
  "Slovak",
  "Slovenian",
  "English",
  "Farsi",
  "Finnish",
  "French",
  "French (Canadian)",
  "Georgian",
  "German",
  "Greek",
  "Haitian Creole",
  "Hebrew",
  "Hindi",
  "Hungarian",
  "Indonesian",
  "Italian",
  "Japanese",
  "Korean",
  "Latvian",
  "Lithuanian",
  "Malay",
  "Nepali",
  "Norwegian",
  "Polish",
  "Portuguese (Brazil)",
  "Portuguese (Portugal)",
  "Punjabi",
  "Spanish",
  "Swedish",
  "Tagalog",
  "Tamil",
  "Thai",
  "Turkish",
  "Ukrainian",
  "Urdu",
  "Vietnamese",
];
